import(/* webpackMode: "eager", webpackExports: ["GeneralStoreProvider"] */ "/home/jenkins/agent/workspace/fipe-next-ui-prd/src/providers/general-store-provider.tsx");
